import { constants } from '../constants';
import { DI_CONSTANTS } from '../di-types';
import { Container, interfaces } from 'inversify';

export const registerConstants = (
  container: Container,
  containerConstants: typeof constants = constants
): Container => {
  for (const name in DI_CONSTANTS) {
    const value = containerConstants[name];
    if (value !== undefined) {
      container.bind<typeof value>(DI_CONSTANTS[name]).toConstantValue(value);
    }
  }
  return container;
};

// The evaluate() function should be a singleton, loaded only once.
// Found this answer by the author of InversifyJS on how to accomplish that with
// ProviderCreators: https://github.com/inversify/InversifyJS/issues/397#issuecomment-257450642
export const dynamicModuleProvider = <ModuleType, ExportType>(
  moduleLoader: () => Promise<ModuleType>,
  exportGetter: (m: ModuleType) => ExportType
): interfaces.ProviderCreator<ExportType> => (
  context: interfaces.Context
): interfaces.Provider<ExportType> => {
  let module: Promise<ModuleType> | undefined = undefined;
  const getExport = (modulePromise: Promise<ModuleType>) => modulePromise.then(exportGetter);
  return () => {
    if (module === undefined) {
      module = moduleLoader();
      return getExport(module);
    } else {
      return getExport(module);
    }
  };
};
